import { lazy } from "react";
import { Navigate } from "react-router-dom";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import UserLimitedDialog from "ui-component/dialogs/UserLimitedDialog";

// sample page routing
const ExpenseForm = Loadable(lazy(() => import("views/pages/forms/ExpenseForm")));
const ExpenseFormEdit = Loadable(lazy(() => import("views/pages/forms/ExpenseFormEdit")));
const ExpenseFormDetail = Loadable(lazy(() => import("views/pages/formDetails/ExpenseFormDetail")));
const AccountedFormDetail = Loadable(
  lazy(() => import("views/pages/formDetails/AccountedFormDetail"))
);
const ExpenseList = Loadable(lazy(() => import("views/pages/list/ExpenseList")));
const AccountedList = Loadable(lazy(() => import("views/pages/list/AccountedList")));
const ErrorPage = Loadable(lazy(() => import("views/pages/ErrorPage")));
const ChangePassword = Loadable(lazy(() => import("views/pages/profile/change-password")));
const UserManagement = Loadable(lazy(() => import("views/pages/profile/user-management")));
const MailLog = Loadable(lazy(() => import("views/pages/profile/mail-log")));
const Dashboard = Loadable(lazy(() => import("views/pages/dashboard/Dashboard")));
const AccountantManagement = Loadable(
  lazy(() => import("views/pages/profile/accountant-management"))
);
const AdvanceList = Loadable(lazy(() => import("views/pages/list/AdvanceList")));
const MotivationBudgetList = Loadable(lazy(() => import("views/pages/list/MotivationBudgetList")));
const AdvanceForm = Loadable(lazy(() => import("views/pages/forms/AdvanceForm")));
const AdvanceFormEdit = Loadable(lazy(() => import("views/pages/forms/AdvanceFormEdit")));
const AdvanceFormDetail = Loadable(lazy(() => import("views/pages/formDetails/AdvanceFormDetail")));
const AdvanceAccountedList = Loadable(lazy(() => import("views/pages/list/AdvanceAccountedList")));
const RegionApproverMatching = Loadable(
  lazy(() => import("views/pages/profile/region-approver-matching"))
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/",
      element: <Navigate replace to="/dashboard" />,
    },
    {
      path: "expense-detail",
      element: <ExpenseFormDetail />,
    },
    {
      path: "expense-form",
      element: <ExpenseForm />,
    },
    {
      path: "expense-list",
      element: <ExpenseList />,
    },
    {
      path: "accounted-list",
      element: <AccountedList />,
    },
    {
      path: "accounted-detail",
      element: <AccountedFormDetail />,
    },
    {
      path: "dashboard",
      element: <Dashboard />,
    },
    {
      path: "change-password",
      element: <ChangePassword />,
    },
    {
      path: "user-management",
      element: <UserManagement />,
    },
    {
      path: "mail-log",
      element: <MailLog />,
    },
    { path: "region-approver-matching", element: <RegionApproverMatching /> },
    {
      path: "accountant-management",
      element: <AccountantManagement />,
    },
    {
      path: "/userLimited",
      element: <UserLimitedDialog />,
    },
    {
      path: "expense-form-edit",
      element: <ExpenseFormEdit />,
    },
    {
      path: "my-approved",
      element: <ExpenseList />,
    },
    {
      path: "advance-list",
      element: <AdvanceList />,
    },
    {
      path: "my-approved-advance",
      element: <AdvanceList />,
    },
    {
      path: "motivation-budget-list",
      element: <MotivationBudgetList />,
    },
    {
      path: "advance-form",
      element: <AdvanceForm />,
    },
    {
      path: "advance-form-edit",
      element: <AdvanceFormEdit />,
    },
    {
      path: "advance-detail",
      element: <AdvanceFormDetail />,
    },
    {
      path: "*",
      element: <ErrorPage />,
    },
    {
      path: "advance-accounted-list",
      element: <AdvanceAccountedList />,
    },
  ],
};

export default MainRoutes;
